module.exports = __webpack_public_path__ + "static/img/103432.8acf39cc.png";